/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Signupsnav1Inputs */

const en_signupsnav1 = /** @type {(inputs: Signupsnav1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`New accounts`)
};

const de_signupsnav1 = /** @type {(inputs: Signupsnav1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Neue Konten`)
};

/**
* | output |
* | --- |
* | "New accounts" |
*
* @param {Signupsnav1Inputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
const signupsnav1 = /** @type {((inputs?: Signupsnav1Inputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Signupsnav1Inputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_signupsnav1(inputs)
	return de_signupsnav1(inputs)
});
export { signupsnav1 as "signupsNav" }